let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hVh0q")).then(() => parcelRequire('kSuJt'));